import { z } from 'zod';

import { buildLearnProductSchema } from './consumer-learn';
import { buildSubscriptionProductSchema } from './consumer-sub/subscription-product';

export const buildDraftProductSchema = () =>
  buildLearnProductSchema().extend(buildSubscriptionProductSchema().shape);
export type DraftProduct = z.infer<ReturnType<typeof buildDraftProductSchema>>;
